/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Open_RecipeInputs */

const en_session_open_recipe = /** @type {(inputs: Session_Open_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View recipe`)
};

const de_session_open_recipe = /** @type {(inputs: Session_Open_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept ansehen`)
};

/**
* | output |
* | --- |
* | "View recipe" |
*
* @param {Session_Open_RecipeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_open_recipe = /** @type {((inputs?: Session_Open_RecipeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Open_RecipeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_open_recipe(inputs)
	return en_session_open_recipe(inputs)
});